import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiCheckbox from 'features/ui/base-components/pai-checkbox';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;
  name: string | undefined;
  deleteContacts: boolean;

  handleDeleteSearchContactsChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleDeleteSearch(): void;
}

const DeleteSearchDialog: React.FC<Props> = ({
  open,
  loading,
  name,
  deleteContacts,
  handleDeleteSearchContactsChange,
  handleClose,
  handleDeleteSearch,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('deleteContactSearchDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={2}>
          <Stack gap={1}>
            <Typography className={classes.text}>
              <Trans i18nKey={'deleteContactSearchDialogContent1'} values={{ name }}>
                Soll die LinkedIn-Kontakt-Suche <strong>{name}</strong> wirklich gelöscht werden?
              </Trans>
            </Typography>
            <Typography className={classes.text}>{t('deleteContactSearchDialogContent2')}</Typography>
          </Stack>
          <Divider />
          <PaiCheckbox checked={deleteContacts} label={t('deleteAssociatedContacts')} onChange={handleDeleteSearchContactsChange} />
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} loading={loading} action={handleDeleteSearch} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default DeleteSearchDialog;
